export function authHeader() {
    let user_token = JSON.parse(localStorage.getItem('user_token'));
    var headers = new Headers();
    headers.append('Authorization', 'Bearer ' + user_token)
    return headers;
}

export function authHeader_ForPost() {
    let user_token = JSON.parse(localStorage.getItem('user_token'));

    var headers = new Headers();
    headers.append('Authorization', 'Bearer ' + user_token)
    headers.append('Accept', 'application/json'); // This one is enough for GET requests
    headers.append('Content-Type', 'application/json'); // This one sends body
    return headers;
}

export function authHeader_ForFileUpload() {
    let user_token = JSON.parse(localStorage.getItem('user_token'));

    var headers = new Headers();
    headers.append('Authorization', 'Bearer ' + user_token)
    headers.append('Accept', 'application/json'); // This one is enough for GET requests
    return headers;
}